var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.SortingBlock
  }, [_c('SortingMenu', _vm._g({
    attrs: {
      "items": _vm.items,
      "current": _vm.current
    }
  }, _vm.$listeners)), _vm._v(" "), _vm.$slots.middle ? _c('div', {
    class: _vm.$style.middle
  }, [_vm._t("middle")], 2) : _vm._e(), _vm._v(" "), _vm.$slots.append ? _c('div', {
    class: _vm.$style.wrapper
  }, [_vm._t("append")], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };